module.exports = __webpack_public_path__ + "media/images/application/template/arrow-right-94b02e32526a916026ef8de6be50e66b.png";